export const bannersDefaultColumns = [
  { label: 'Autor', value: 'author' }, 
  { label: 'Nome do banner', value: 'title' },
  { label: 'Descrição', value: 'description' }, 
  { label: 'Envio', value: 'active_at' },
  { label: 'Expiração', value: 'expires_at' }, 
  { label: 'Ações', value: 'actions', className: 'w-9' }, 
];